// extracted by mini-css-extract-plugin
export default {"container":"fda-z","creativeContainer":"gda-z","copy":"hda-z","cta":"ida-z","disabled":"jda-z","flipped":"kda-z","productCard":"lda-z"};